(ns app.front.view.inspections.visit-result
  (:require [app.domain.execution.model :as execution-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.notes :as ui-notes]
            [app.front.ui.radio :as ui-radio]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.ui.visibility-title :as ui-visibility]
            [app.front.util :as futil]
            [app.front.view.inspections.deficiencies-v2 :as deficiencies-v2]
            [app.front.view.inspections.recurrence :as recurrence]
            [app.front.view.inspections.subs :as inspection-sub]
            [app.front.view.inspections.time-tracking :as time-tracking]
            [app.front.view.inspections.visit :as-alias inspection-visit]
            [app.front.view.inspections.visit.failure-reason :as visit-failure]
            [app.front.view.inspections.visit.result-detail :as visit-result-detail]
            [app.front.view.inspections.visit.result-detail-v2 :as visit-result-detail-v2]
            [app.front.view.occupancy.list :as po-list]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-sub ::visit-result
  (fn [[_ visit-id] _]
    [(rf/subscribe [::ee/attr-value visit-id :inspection.visit/visit-result])
     (rf/subscribe [::entities/context])])
  (fn [[result-id ctx]]
    (entities/find-entity ctx result-id)))

(rf/reg-sub ::result
  (fn [[_ visit-id] _]
    [(rf/subscribe [::ee/attr-value visit-id :inspection.visit/occupancy-result])
     (rf/subscribe [::ee/attr-value visit-id :inspection.visit/result])])
  (fn [[occupancy-result result]]
    (or (inspection-model/visit-result-mapper occupancy-result)
        result)))

(rf/reg-sub ::disabled-results
  :<- [::deficiencies-v2/all-deficiencies]
  :<- [::inspection-visit/current-inspection]
  :<- [::ws-subs/has-feature? :group.feature/inspection-checklists]
  (fn [[all-deficiencies inspection checklists-feature?] _]
    (let [uncleared-deficiencies? (->> all-deficiencies
                                       (remove :inspection.deficiency/remark?)
                                       (map :domain/state)
                                       (filter #{:inspection.deficiency.state/active
                                                 :inspection.deficiency.state/draft})
                                       not-empty)
          checklists-completed?   (->> inspection
                                       inspection-model/checklists
                                       (map :inspection.checklist/completed-for)
                                       (every? #((set %) (-> inspection inspection-model/inspection-active-visit))))]
      (if (or uncleared-deficiencies?
              (and checklists-feature? (not checklists-completed?)))
        #{:inspection.visit.result/passed
          :inspection.visit.occupancy-result/occupancy-granted}
        #{}))))

(rf/reg-sub ::disabled-visit-results
  :<- [::deficiencies-v2/all-deficiencies]
  :<- [::inspection-visit/current-inspection]
  :<- [::ws-subs/has-feature? :group.feature/inspection-checklists]
  (fn [[all-deficiencies inspection checklists-feature?] _]
    (let [visit-results           (-> inspection :inspection/visit-type :inspection-visit-type/visit-results)
          uncleared-deficiencies? (->> all-deficiencies
                                       (remove :inspection.deficiency/remark?)
                                       (map :domain/state)
                                       (filter #{:inspection.deficiency.state/active
                                                 :inspection.deficiency.state/draft})
                                       not-empty)
          checklists-completed?   (->> inspection
                                       inspection-model/checklists
                                       (map :inspection.checklist/completed-for)
                                       (every? #((set %) (-> inspection inspection-model/inspection-active-visit))))]
      (if (or uncleared-deficiencies?
              (and checklists-feature? (not checklists-completed?)))
        (->> visit-results
             (filter (fn [result] (-> result :inspection-visit-result/rules (contains? :inspection.visit.result-rule/no-deficiencies-allowed)))))
        #{}))))


(rf/reg-sub ::bills-guard-blocking?
  (fn [[_ target-entity signal-with-params] _]
    (rf/subscribe [::process/signal-errors-for-error-list target-entity signal-with-params]))
  (fn [blocking-guards _]
    (some #(= :process.guard/outstanding-bills-paid-or-override? (first %)) blocking-guards)))


(rf/reg-sub ::partial-occupancy-apps
  :<- [::po-list/partial-occupancy-apps]
  (fn [apps]
    (->> apps
         (filter #(-> % :domain/state (= :partial-occupancy.state/approved)))
         (sort-by :entity/created))))


(rf/reg-sub ::recurrence-values
  (fn [db [_ visit-id]]
    (get-in db [::recurrence visit-id])))


(rf/reg-event-db
  ::set-recurrence-value
  (fn [db [_ visit-id attr value]]
    (assoc-in db [::recurrence visit-id attr] value)))

(rf/reg-sub ::allowed-values
  (fn [_ [_ attr current-value]]
    (let [allowed-values (get {:inspection.visit/result           inspection-model/visit-results
                               :inspection.visit/occupancy-result inspection-model/occupancy-visit-results}
                              attr)]
      ;; add current value if allowed values do not contain it
      (if (or (nil? current-value)
              (some #{current-value} allowed-values))
        allowed-values
        (conj allowed-values current-value)))))

;;Util

(def save-value (ee/save-fn :process.signal/update-inspection-visit))
(def save-value-debounce (ee/save-debounce-fn :process.signal/update-inspection-visit))

(rf/reg-event-db ::set-override-bills
  (fn [db [_ visit-id value]]
    (assoc-in db [::override-bills visit-id] value)))

(rf/reg-sub ::override-bills
  (fn [db [_ visit-id]]
    (get-in db [::override-bills visit-id] false)))

(rf/reg-sub ::end-signal-params
  (fn [[_ visit-id _inspection _booking-id] _]
    [(rf/subscribe [::override-bills visit-id])
     (rf/subscribe [::recurrence-values visit-id])])
  (fn [[override-bills? recurrence-values] [_ visit-id inspection booking-id]]
    (->> (p/assoc-if {:visit-id visit-id}
                     :booking-id booking-id
                     :override-outstanding-bill? override-bills?)
         (recurrence/add-to-visit-end-signal-params inspection recurrence-values))))

(def desc-visibility
  {:inspection.visit/internal-notes :internal
   :inspection.visit/notes          :public})


;;Components

(defn simple-text-area [{:keys [attr tr visit-id target-entity disabled?]}]
  [ui/text-area {:id         (name attr)
                 :label-text (tr [attr])
                 :on-change  #(save-value-debounce target-entity visit-id attr (-> % futil/tval identity))
                 :on-blur    #(save-value target-entity visit-id attr (-> % futil/tval identity))
                 :value      (<sub [::ee/attr-value visit-id attr])
                 :disabled   disabled?}])

(defn result-notes [{:keys [attr tr visit-id target-entity auth-group disabled?]}]
  [ui-rt/editor-legacy {:initial-value           (<sub [::ee/attr-value visit-id attr])
                        :id                      (name attr)
                        :label-text              [ui-visibility/visibility-title
                                                  {:visibility (desc-visibility attr)
                                                   :tr         tr}
                                                  (str (tr [attr]) " (" (tr [:optional]) ")")]
                        :on-change               (when (not disabled?) #(save-value-debounce target-entity visit-id attr %))
                        :default-phrase-category (-> auth-group :group/phrase-category-inspections)
                        :authority-group-id      (:db/id auth-group)
                        :placeholder             (tr [(keyword (namespace attr) (str (name attr) "-placeholder"))])}])

(def result-container :div.uppercase.mt-2.text-xs.text-gray-700)

(defn inspection-result-display [{:keys [tr visit-id]}]
  (let [result      (<sub [::visit-result visit-id])
        status-type (:inspection-visit-result/status-type result)]
    (case (:inspection-visit-result/status-type result)
      :inspection.visit.result-status-type/failed [result-container
                                                   (tr [:inspection.visit/result-change])
                                                   [:span.text-fail.font-bold (tr [status-type])]]
      :inspection.visit.result-status-type/passed [result-container
                                                   (tr [:inspection.visit/result-change])
                                                   [:span.text-success.font-bold (tr [status-type])]]
      :inspection.visit.result-status-type/in-progress [result-container
                                                        (tr [:inspection.visit/result-change])
                                                        [:span.font-bold (tr [status-type])]]
      nil)))

(defn visit-type-picker [{:keys [tr visit-id disabled?]} on-change]
  [ui-radio/radio
   {:name      "visit-type"
    :class     "mb-4"
    :values    inspection-model/visit-method
    :disabled  disabled?
    :value     (or (<sub [::ee/attr-value visit-id :inspection.visit/type])
                   inspection-model/default-visit-method)
    :on-change on-change
    :val->str  #(tr [%])}])

(defn result-select [{:keys [tr attr on-change visit-id disabled?]}]
  (let [value (<sub [::ee/attr-value visit-id attr])]
    [ui-select/select
     {:values          (<sub [::allowed-values attr value])
      :disabled        disabled?
      :disabled-values (<sub [::disabled-results])
      :id              (name attr)
      :label-text      (tr [attr])
      :val->str        #(tr [(or % :select-option)])
      :on-change       #(on-change attr %)
      :value           value
      :required        true
      :allow-empty?    false
      :class-name      "full-width-select"}]))

(defn visit-result-select [{:keys [tr on-change visit-id visit-type disabled?]}]
  (let [lang   (<sub [:language])
        value  (<sub [::ee/attr-value visit-id :inspection.visit/visit-result])
        values (->> visit-type
                    :inspection-visit-type/visit-results
                    (filter du/is-active?)
                    (sort-by :inspection-visit-result/names (i18n-model/localized-string-comparator lang)))]
    [ui-select/select
     {:values          values
      :disabled        disabled?
      :disabled-values (<sub [::disabled-visit-results])
      :id              "result"
      :label-text      (tr [:inspection.visit/result])
      :val->str        (fn [result]
                         (if result
                           (-> result :inspection-visit-result/names (i18n-model/get-text-from-entities-or-map lang))
                           (tr [:select-option])))
      :on-change       #(on-change :inspection.visit/visit-result (:db/id %))
      :value           (-> values (p/find-first {:db/id value}))
      :required        true
      :allow-empty?    false
      :class-name      "full-width-select"}]))

(rf/reg-sub ::pending-save?
  (fn [[_ visit-id] _]
    [(rf/subscribe [::process/signal-processing? :process.signal/update-inspection-visit])
     (rf/subscribe [::ee/has-changes? visit-id])])
  (fn [[processing? unsaved-changes?] _]
    (or processing? unsaved-changes?)))


(defn cancel-and-save-buttons [{:keys [target-entity inspection tr visit visit-id booking-id]} end-visit-disabled? visits-conf?]
  (let [end-signal-params      (<sub [::end-signal-params visit-id inspection booking-id])
        end-signal-candidates  (->> visit
                                    inspection-model/inspection-visit-end-signal-id-candidates
                                    (mapv #(vector % end-signal-params)))
        primary-end-signal     (first (<sub [::process/signals-available target-entity end-signal-candidates]))
        primary-end-signal-id  (first primary-end-signal)
        override-bills?        (<sub [::override-bills visit-id])
        end-signal-disabled?   (not (<sub [::process/signal-permitted? target-entity primary-end-signal]))
        end-visit-in-progress? (<sub [::process/signal-processing? primary-end-signal])
        updating-visit?        (<sub [::pending-save? visit-id])
        blocked-by-bills?      (and (not override-bills?)
                                    (<sub [::bills-guard-blocking? target-entity primary-end-signal]))]
    [:div.mt-4.flex.flex-col.w-full
     (when blocked-by-bills?
       [:div.mb-2.flex.flex-col.gap-2
        [:div.text-sm.text-red-600
         (tr [:inspection.visit/blocked-by-unpaid-bills])]
        [:label.flex.items-center.text-sm.cursor-pointer
         [:input.mr-2
          {:type      "checkbox"
           :checked   override-bills?
           :on-change #(>evt [::set-override-bills visit-id (-> % .-target .-checked)])}]
         (tr [:inspection.visit/override-bill-restriction])]])
     [:div.flex.items-baseline.w-full.justify-end
      [:a.mr-2
       {:href     "#"
        :on-click #(>evt [::process/signal
                          target-entity
                          [:process.signal/cancel-inspection-visit
                           {:visit-id visit-id}]])}
       (tr [:cancel])]
      [ui/modal-confirmation-button
       {:tr                  tr
        :modal-title         (tr [:inspection.visit/really-end])
        :trigger-button-text (tr [(if visits-conf? primary-end-signal-id :inspection.visit/end-visit)])
        :trigger-button-opts {:icon          i/stop-filled
                              :icon-position :right
                              :disabled      (or end-visit-disabled?
                                                 end-visit-in-progress?
                                                 end-signal-disabled?)}
        :yes-disabled?       updating-visit?
        :on-yes-click        #(>evt [::process/signal
                                     target-entity
                                     primary-end-signal])}
       [:div.gap-4.flex.flex-col
        [:div (tr [:inspection.visit/end-visit-help])]
        (when updating-visit?
          [:div.py-2
           (cc/loading-spinner {:with-overlay false :small true})])]]]]))

(defn pdf-template-select [{:keys [tr on-change occupancy-granted? visit visit-id disabled?]} pdf-templates]
  (r/with-let [*user-changed-val (r/atom false)]
    (let [attr (-> visit inspection-model/visit->template-attributes :template-attr)]
      (when (and (seq pdf-templates)
                 ;; Show select for report templates iff there are multiple templates or template-attr for visit is nil
                 ;; Note that occupancy permit template can have nil value
                 (or occupancy-granted?
                     @*user-changed-val
                     (seq (rest pdf-templates))
                     (nil? (<sub [::ee/attr-value visit-id attr]))))
        [ui-select/select
         {:values       (map :db/id pdf-templates)
          :class-name   "full-width-select"
          :id           "pdf-template-select"
          :label-text   (tr (if occupancy-granted?
                              [:inspection.visit/occupancy-template-select]
                              [:inspection.visit/inspection-report-template-select]))
          :val->str     (fn [template]
                          (-> pdf-templates
                              (p/find-first #(-> % :db/id (= template)))
                              :inspection.pdf-template/name))
          :select-text  (tr [:inspection.visit/none])
          :on-change    (fn [template]
                          (reset! *user-changed-val true)
                          (on-change attr template))
          :value        (<sub [::ee/attr-value visit-id attr])
          :required     false
          :disabled     disabled?
          :allow-empty? occupancy-granted?}]))))


(defn partial-occupancy-select [{:keys [tr visit set-value auth-group]}]
  (let [po-apps (<sub [::partial-occupancy-apps])]
    (when (seq po-apps)
      [ui-select/select
       {:values       po-apps
        :class-name   "full-width-select mt-2"
        :id           "pdf-template-select"
        :label-text   (tr [:inspection.visit/partial-occupancy-select])
        :val->str     (fn [{:partial-occupancy/keys [area-to-be-occupied
                                                     expected-date-of-occupancy
                                                     description-of-request]}]
                        (->> [(date-util/date-in-tz expected-date-of-occupancy (:group/tz auth-group))
                              (str area-to-be-occupied " m²")
                              (futil/ellipsis description-of-request 88)]
                             (str/join ", ")))
        :on-change    #(set-value :inspection.visit/partial-occupancy (:db/id %))
        :value        (:inspection.visit/partial-occupancy visit)
        :required     false
        :allow-empty? true}])))

(defn visit-result-detail-v2 [{:keys [visit-id tr set-value disabled?]}]
  (let [visit-result   (<sub [::visit-result visit-id])
        result-details (<sub [::visit-result-detail-v2/result-details visit-result])
        required?      (inspection-model/visit-result-rule-set? visit-result :inspection.visit.result-rule/reason-required)]
    (if (seq result-details)
      [visit-result-detail-v2/multiple-result-detail-picker (util/mmap visit-result set-value visit-id tr disabled? required?)]
      (when required?
        [ui/warning (tr [:group.config/inspection-visit-result-reasons-missing])]))))

(defn failure-reason-enabled? [result]
  (= result :inspection.visit.result/failed))

(defn visit-result-detail [{:keys [visit-id tr set-value disabled?]}]
  (let [visit-result   (<sub [::result visit-id])
        result-details (<sub [::visit-result-detail/result-details visit-result])]
    (cond
      (seq result-details)
      [visit-result-detail/result-detail-picker (util/mmap visit-result set-value visit-id tr disabled?)]
      (failure-reason-enabled? visit-result)
      [visit-failure/failure-reason-picker (util/mmap visit-id tr set-value disabled?)])))

(defn stakeholder-notification-note [tr inspection visit-result]
  (let [kind              (-> inspection :inspection/template :entity/parent)
        notifying-results (some->> kind :inspection.template.kind/end-visit-notification-for-results (keep :db/id) set)]
    (when (and (:inspection.template.kind/visit-completion-notifies? kind)
               (contains? notifying-results (:db/id visit-result)))
      [:h4.mt-2 (tr [:inspection.visit/triggers-stakeholder-notification])])))

(defn visit-datetime-picker [{:keys [attr tr visit-id target-entity disabled?]}]
  [ui/datetime-picker {:tz         (-> target-entity
                                       execution-model/workspace
                                       :domain/authority-group
                                       :group/tz)
                       :datetime   (<sub [::ee/attr-value visit-id attr])
                       :date-label (tr [:inspection.visit/visit-date])
                       :time-label (tr [:inspection.visit/visit-start-time])
                       :max-date   (date-util/today-start-of-day)
                       :on-change  #(save-value-debounce target-entity visit-id attr %)
                       :disabled?  disabled?}])

(defn result-section [end-visit-disabled?
                      {:keys                                   [tr target-entity auth-group inspection]
                       {visit-id :db/id :as visit}             :visit
                       {:inspection/keys [visit-type subtype]} :inspection
                       :as                                     props}]
  (let [visits-conf?         (<sub [::inspection-sub/visit-configuration-enabled?])
        set-value            (partial save-value target-entity visit-id)
        set-value-debounce   (partial save-value-debounce target-entity visit-id)
        show-internal-notes? (and (not (<sub [::ws-subs/has-feature? :group.feature/hide-internal-notes]))
                                  (-> target-entity :granted-permissions :permission.inspection/authority-read))
        occupancy?           (or (and visits-conf?
                                      (some-> visit-type :inspection-visit-type/workflow (= :inspection.visit.type-workflow/occupancy-inspection)))
                                 (= subtype :inspection.subtype/occupancy))
        visit-result         (when occupancy?
                               (if visits-conf?
                                 (<sub [::visit-result visit-id])
                                 (<sub [::ee/attr-value visit-id :inspection.visit/occupancy-result])))
        occupancy-granted?   (if visits-conf?
                               (some-> visit-result :inspection-visit-result/status-type inspection-model/occupancy-granted-result-status-types)
                               (contains? inspection-model/occupancy-granted-results visit-result))
        pdf-templates        (->> (<sub [::entities/entities
                                         {:entity/type            :entity.type/inspection-pdf-template
                                          :domain/authority-group (:db/id auth-group)}])
                                  (inspection-model/filter-inspection-templates visit))
        disabled?            (not (<sub [::process/signal-permitted?
                                         (:db/id target-entity)
                                         [:process.signal/update-inspection-visit {:id visit-id}]]))
        props                (merge props
                                    (util/mmap visit visit-id visit occupancy-granted? disabled?))]
    (when visit
      (if (<sub [::ws-subs/loading-config?])
        [section/section-skeleton]
        [section/section
         "inspection-result-section"
         props
         :inspection.visit/full-result
         [:div
          [visit-datetime-picker (util/mmap {:attr :inspection.visit/start-time} visit-id tr target-entity disabled?)]
          [visit-type-picker props (partial set-value :inspection.visit/type)]
          [(if show-internal-notes? ui-notes/two-cols :div.mt-4.flex)
           (when show-internal-notes?
             [result-notes (util/mmap {:attr :inspection.visit/internal-notes}
                                      visit-id tr target-entity auth-group disabled?)])
           [result-notes (util/mmap {:attr :inspection.visit/notes}
                                    visit-id tr target-entity auth-group disabled?)]]
          [:div.mt-2
           [ui-notes/two-cols
            [:div.flex.flex-1.w-full.flex-wrap.items-start
             [:div.flex.flex-0.flex-col.w-full.lg:w-3-5.xl:w-2-3.mt-2.pr-0.lg:pr-2
              (if visits-conf?
                [visit-result-select (util/mmap {:on-change set-value}
                                                tr visit-id disabled? visit-type)]
                [result-select (util/mmap {:attr      (if occupancy?
                                                        :inspection.visit/occupancy-result
                                                        :inspection.visit/result)
                                           :on-change set-value}
                                          tr visit-id disabled?)])
              [inspection-result-display
               {:tr tr :visit-id visit-id}]
              (when (<sub [::ff/enabled? :feature-flag.id/inspection-stakeholder-notifications])
                [stakeholder-notification-note tr inspection (<sub [::visit-result visit-id])])]
             (when occupancy-granted?
               [:div.w-full.lg:w-2-5.xl:w-1-3.mt-2.occupancy-granted-date-picker
                [ui/date-picker {:id         "occupancy-granted-date"
                                 :callback   (partial set-value :inspection.visit/occupancy-granted-date)
                                 :value      (:inspection.visit/occupancy-granted-date visit)
                                 :label-text (tr [:inspection.visit/occupancy-granted-date])
                                 :disabled?  disabled?
                                 :width      "100%"}]])]
            [:div.mt-2
             (if visits-conf?
               [visit-result-detail-v2 (util/mmap visit-id tr set-value disabled?)]
               [visit-result-detail (util/mmap visit-id tr set-value disabled?)])
             [pdf-template-select
              (assoc props :on-change set-value)
              pdf-templates]
             (when occupancy-granted?
               [partial-occupancy-select (util/mmap tr visit set-value auth-group)])]]
           [:div.mt-4
            [ui-notes/two-cols
             (when occupancy-granted?
               [simple-text-area (assoc props :attr :inspection.visit/occupancy-description)])
             (when (or (inspection-model/result-status-type-is? :inspection.visit.result-status-type/in-progress visit-result)
                       (= visit-result :inspection.visit.occupancy-result/occupancy-granted-but-outstanding-matters))
               [simple-text-area (assoc props :attr :inspection.visit/occupancy-outstanding-matters)])]]
           (when (<sub [::time-tracking/enabled?])
             [:div.mt-2
              [time-tracking/time-tracking {:tr        tr
                                            :value     (<sub [::ee/attr-value visit-id :inspection.visit/time-spent])
                                            :on-change (partial set-value-debounce :inspection.visit/time-spent)
                                            :on-blur   (partial set-value :inspection.visit/time-spent)}]])
           [recurrence/view
            (merge props
                   {:class       "w-full lg:w-1-2"
                    :values      (<sub [::recurrence-values visit-id])
                    :visit-state (or (<sub [::visit-result visit-id])
                                     (<sub [::result visit-id]))
                    :on-change   #(>evt [::set-recurrence-value visit-id :create-inspection? %])})]
           [cancel-and-save-buttons props (or disabled? end-visit-disabled?) visits-conf?]]]]))))
